import { MatchField } from '@mews-commander/guest-profile';
import { TooltippedIcon } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import { createHandler } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { IconName, Typography } from '@optimus-web/core';

const getHeadingTextKey = createHandler<MatchField, keyof typeof TextKey | null>(
    {
        [MatchField.BirthDate]: 'BirthDate',
        [MatchField.Email]: 'Email',
        [MatchField.FirstName]: 'FirstName',
        [MatchField.LastName]: 'LastName',
        [MatchField.PaymentCard]: 'PaymentCard',
        [MatchField.Phone]: 'Phone',
        [MatchField.SecondLastName]: 'SecondLastName',
    },
    null
);

const tooltipedIcon = (tooltip: string) => (
    <>
        {UnicodeEntity.NoBreakSpace}
        <TooltippedIcon size="small" value={IconName.Info} tooltip={tooltip} />
    </>
);

export const FieldHeading = ({ property }: { property: MatchField }) => {
    const textKey = getHeadingTextKey(property);

    return (
        <Typography textStyle="bodyMediumStrong" align="center" as="div">
            {textKey ? lt(textKey) : null}
            {property === MatchField.PaymentCard ? tooltipedIcon('AccountMergeMatchingFieldsPaymentCardTooltip') : null}
        </Typography>
    );
};
